import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedTeamsShowProjectsShowProjectVersionsIndexRoute extends BaseRoute {}
